import { render, staticRenderFns } from "./Bathrooms.vue?vue&type=template&id=bffcbb78"
import script from "./Bathrooms.vue?vue&type=script&lang=js"
export * from "./Bathrooms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports